import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import Button from '../button/Button';
import { MaxContentWrapper } from '../max-content-wrapper/MaxContentWrapper';
import Typography from '../typography/Typography';
import { PageNotFoundContentWrapper, PageNotFounImg, ButtonWrapper, Description, } from './styles';
const PageNotFoundContent = ({ imageUrl, title, description, buttonText, shouldHaveMargin, }) => {
    const navigate = useNavigate();
    const onClick = () => {
        navigate('/');
    };
    return (_jsx(MaxContentWrapper, { children: _jsxs(PageNotFoundContentWrapper, { shouldHaveMargin: shouldHaveMargin, children: [_jsx(PageNotFounImg, { src: imageUrl, alt: "page-not-found-image" }), _jsx(Typography, { type: "largeTitle", fontFamily: "primaryBold", children: title }), _jsx(Description, { type: "subHeadline", children: description }), _jsx(ButtonWrapper, { children: _jsx(Button, { onClick: onClick, title: buttonText, buttonType: "primary" }) })] }) }));
};
export default PageNotFoundContent;
//# sourceMappingURL=PageNotFoundContent.js.map